import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_DATA } from 'reducers/myJobs/reducer'

// constants
export const FETCH_LOCUS_GROUP_LIST = 'locusGroup/FETCH_LOCUS_GROUP_LIST'
export const SUCCESS_LOCUS_GROUP_LIST = 'locusGroup/SUCCESS_LOCUS_GROUP_LIST'
export const FAILURE_LOCUS_GROUP_LIST = 'locusGroup/FAILURE_LOCUS_GROUP_LIST'
export const LOAD_LOCUS_GROUP_LIST = 'locusGroup/LOAD_LOCUS_GROUP_LIST'

export const FETCH_LOCUS_GROUP_TABLE = 'locusGroup/FETCH_LOCUS_GROUP_TABLE'
export const SUCCESS_LOCUS_GROUP_TABLE = 'locusGroup/SUCCESS_LOCUS_GROUP_TABLE'
export const FAILURE_LOCUS_GROUP_TABLE = 'locusGroup/FAILURE_LOCUS_GROUP_TABLE'
export const LOAD_LOCUS_GROUP_TABLE = 'locusGroup/LOAD_LOCUS_GROUP_TABLE'

export const FETCH_LOCUS_GROUP_FORM = 'locusGroup/FETCH_LOCUS_GROUP_FORM'
export const SUCCESS_LOCUS_GROUP_FORM = 'locusGroup/SUCCESS_LOCUS_GROUP_FORM'
export const FAILURE_LOCUS_GROUP_FORM = 'locusGroup/FAILURE_LOCUS_GROUP_FORM'
export const LOAD_LOCUS_GROUP_FORM = 'locusGroup/LOAD_LOCUS_GROUP_FORM'

export const SET_LOCUS_GROUP_INFO = 'locusGroup/SET_LOCUS_GROUP_INFO'
export const DELETE_LOCUS_GROUP_INFO = 'locusGroup/DELETE_LOCUS_GROUP_INFO'

export const CLEAR_LOCUS_GROUP_STORE = 'locusGroup/CLEAR_LOCUS_GROUP_STORE'

// actions
export const fetchLocusGroupList = ActionHelper.createActionObj(
  FETCH_LOCUS_GROUP_LIST,
)
export const fetchLocusGroupTable = ActionHelper.createActionObj(
  FETCH_LOCUS_GROUP_TABLE,
)
export const fetchLocusGroupForm = ActionHelper.createActionObj(
  FETCH_LOCUS_GROUP_FORM,
)
export const setLocusGroupInfo = ActionHelper.createActionObj(
  SET_LOCUS_GROUP_INFO,
)
export const deleteLocusGroupInfo = ActionHelper.createActionObj(
  DELETE_LOCUS_GROUP_INFO,
)
export const clearLocusGroupStore = ActionHelper.createActionObj(
  CLEAR_LOCUS_GROUP_STORE,
)

// state
const initialState = () =>
  fromJS({
    isLoadList: false,
    isLoadTable: false,
    isLoadForm: false,
    locusGroupList: [],
    tableData: {
      data: [],
      count: 0,
    },
    formData: {
      sites: [],
      locusGroup: null,
    },
  })

// reducers
const locusGroup = handleActions(
  {
    [SUCCESS_LOCUS_GROUP_LIST]: (state, action) =>
      state.set('locusGroupList', List(action.payload)),
    [FAILURE_LOCUS_GROUP_LIST]: state => state.set('locusGroupList', List([])),
    [LOAD_LOCUS_GROUP_LIST]: (state, action) =>
      state.set('isLoadList', Boolean(action.payload)),

    [SUCCESS_LOCUS_GROUP_TABLE]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [FAILURE_LOCUS_GROUP_TABLE]: state =>
      state.set(
        'tableData',
        Map({
          data: [],
          count: 0,
        }),
      ),
    [LOAD_LOCUS_GROUP_TABLE]: (state, action) =>
      state.set('isLoadTable', Boolean(action.payload)),

    [SUCCESS_LOCUS_GROUP_FORM]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [FAILURE_LOCUS_GROUP_FORM]: state =>
      state.set(
        'formData',
        Map({
          sites: [],
          locusGroup: null,
        }),
      ),
    [LOAD_LOCUS_GROUP_FORM]: (state, action) =>
      state.set('isLoadForm', Boolean(action.payload)),
    [RESET_DATA]: state => state.set('locusGroupList', List([])),
  },
  initialState(),
)

export default locusGroup
